import { BaseAgent } from 'agents';

const FamilyAgent = {
    family: () => BaseAgent.get('/payment/family'),
    addMember: (data: any) => BaseAgent.post('/payment/family/add', data),
    removeMember: (data: any) => BaseAgent.post('/payment/family/remove', data),
    leave: () => BaseAgent.post('/payment/family/leave'),
};

export default FamilyAgent;
